import * as React from 'react';
import {useEffect, useState} from 'react';
import {ApplicationFactory} from './Application';
import {ApplicationProvider} from './ApplicationProvider';
import AppRouter from './AppRouter';
import {observer} from 'mobx-react';
import {SnackbarProvider} from "notistack";
import SaporeThemeProvider from "./themes/ThemeProvider";
import {ErrorSnackbar, InfoSnackbar, SuccessSnackbar, WarningSnackbar} from "./components/toast/BrandSnackbar";

function App() {
    const [application, setApplicationInstance] = useState();

    useEffect(() => {
        const initializeApplication = async () => {
            const applicationFactory = new ApplicationFactory();
            const currentApplication = await applicationFactory.create();
            setApplicationInstance(currentApplication);
        };
        if (application === undefined) {
            initializeApplication();
        }
    }, []);

    return (
        <SaporeThemeProvider>
            {
                application &&
                <ApplicationProvider application={application}>
                    <SnackbarProvider
                        maxSnack={3}
                        autoHideDuration={4000}
                        anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                        Components={{
                            success: SuccessSnackbar,
                            error: ErrorSnackbar,
                            warning: WarningSnackbar,
                            info: InfoSnackbar,
                        }}
                    >
                        <AppRouter/>
                    </SnackbarProvider>
                </ApplicationProvider>
            }
        </SaporeThemeProvider>
    );
}

export default observer(App);
